// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  font-family: "Segoe","Segoe UI","Arial","sans-serif";
}
p{
  padding: 0px;
  margin: 0px;
}
a{
  cursor: pointer;
}
legend{
  width: 0;
}
.text-chitiet{
  cursor: pointer;
  color: #057db2;
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,QAAQ;AACV;AACA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":["body{\r\n  font-family: \"Segoe\",\"Segoe UI\",\"Arial\",\"sans-serif\";\r\n}\r\np{\r\n  padding: 0px;\r\n  margin: 0px;\r\n}\r\na{\r\n  cursor: pointer;\r\n}\r\nlegend{\r\n  width: 0;\r\n}\r\n.text-chitiet{\r\n  cursor: pointer;\r\n  color: #057db2;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
